var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{key:_vm.configuration.id,tag:"component",attrs:{"id":_vm.configuration.id,"configuration":_vm.configuration}})
}
var staticRenderFns = []

export { render, staticRenderFns }